export default theme => ({
  row: {
    "&:hover *": {
      color: theme.palette.shadow.dark,
      fontWeight: "unset",
    },
    "&:hover div.MuiChip-root": {
      border: `1px solid ${theme.palette.shadow.main}`,
    },
  },
  alert: {
    background: theme.palette.secondary.light,
    "& *": {
      color: theme.palette.secondary.dark,
    },
  },
  future: {
    background: theme.palette.blue.light,
    "& *": {
      color: theme.palette.blue.dark,
    },
  },
  deleted: {
    background: theme.palette.shadow.light,
    "& *": {
      color: theme.palette.shadow.dark,
    },
  },
  alertText: {
    textTransform: "uppercase",
    fontSize: 15,
  },
  alertLink: {
    textDecoration: "underline !important",
  },
  deployment: {
    marginTop: 5,
  },
  status: {
    marginTop: 5,
  },
  date: {
    fontWeight: "initial",
    fontSize: theme.textSizes[1],
  },
  title: {
    fontWeight: 500,
  },
  actions: {
    float: "right",
  },
  status__alert: {
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
  },
  status__future: {
    color: theme.palette.blue.main,
    border: `1px solid ${theme.palette.blue.main}`,
  },
  status__deleted: {
    color: theme.palette.shadow.main,
    border: `1px solid ${theme.palette.shadow.main}`,
  },
  cell: {
    display: "flex",
    justifyContent: "space-between",
    "@media(max-width: 600px)": {
      flexWrap: "wrap",
    },
  },
  iconButton: {
    padding: 9,
  },
});
